import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  ALLIANCE_FORM_FIELDS_QUERY_KEY,
  type FormFieldItem,
  type FormFieldsResponse,
} from './useFetchFormFields';

interface UpdateFormFieldItem {
  field_type: FormFieldItem['field_type'];
  field_key?: string | null;
  custom_field_id?: number | null;
  is_required: boolean;
}

interface UpdateFormFieldsParams {
  form_fields: UpdateFormFieldItem[];
}

export default function useUpdateFormFields() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateFormFieldsParams) => {
      const response = await fetch('/agent/api/alliance_setting/update_form_fields', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({ form_fields: params.form_fields }),
      });

      if (!response.ok) {
        let errorMessage = '応募項目設定の更新に失敗しました';
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        } catch {
          // レスポンスのパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }

      const data: FormFieldsResponse = await response.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ALLIANCE_FORM_FIELDS_QUERY_KEY });
    },
  });
}
